import { c as _c } from "react/compiler-runtime";
import { FileSourceEnum } from '@systemeio/file-manager';
import { MailingId } from 'modules/mailing/types/mailing-interface';
import { getFilteredAttachmentsList } from 'modules/profile/mailing-settings/utils/file-utils';
import React from 'react';
import { useAttachmentsPolicy } from 'shared/components/dashboard-mail-editor/hooks/use-attachments-policy';
import { AttachmentFileInterface, UnsavedAttachmentFileInterface } from 'shared/components/dashboard-mail-editor/types/email-interface';
import { concatAttachments } from 'shared/components/dashboard-mail-editor/utils/concat-attachments';
import { DisclosureBox } from 'shared/components/disclosure-box';
import { FieldErrorAndDescription } from 'shared/components/form/field-error-and-description';
import { SectionMessage } from 'shared/components/section-message';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { twJoin } from 'tailwind-merge';
import { DashboardMailEditorCommonProps } from '../types/common';
import { FileUploaderWithListedFiles } from 'shared/components/file-uploader/file-uploader-with-listed-files';
export interface AttachmentsBlockProps extends Pick<DashboardMailEditorCommonProps, 'isPreFetching' | 'inModal' | 'disabled'> {
  attachmentsTempState: (AttachmentFileInterface | UnsavedAttachmentFileInterface)[];
  setAttachmentsTempState: React.Dispatch<React.SetStateAction<(AttachmentFileInterface | UnsavedAttachmentFileInterface)[]>>;
  mailingId?: MailingId;
  errors: string | undefined;
}
const AttachmentsBlock = t0 => {
  const $ = _c(31);
  const {
    isPreFetching,
    attachmentsTempState,
    setAttachmentsTempState,
    inModal,
    mailingId,
    errors
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    data
  } = useAttachmentsPolicy(mailingId);
  const t1 = inModal && "border border-text-secondary/30 rounded-lg";
  let t2;
  if ($[0] !== t1) {
    t2 = twJoin(t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = t("dashboard.email.attachments");
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <b className="text-text-primary text-start text-[17px]">{t3}</b>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== data?.willBeSentAsLinks || $[7] !== t) {
    t5 = data?.willBeSentAsLinks && <SectionMessage textClassName="text-brand-primary" iconClassName="fill-brand-primary" className="border-brand-primary bg-brand-primary/10">{t("dashboard.email.attachments_as_links")}</SectionMessage>;
    $[6] = data?.willBeSentAsLinks;
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== attachmentsTempState) {
    t6 = attachmentsTempState.map(_temp);
    $[9] = attachmentsTempState;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== setAttachmentsTempState) {
    t7 = file => {
      setAttachmentsTempState(prev => concatAttachments(prev, file));
    };
    $[11] = setAttachmentsTempState;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== attachmentsTempState || $[14] !== setAttachmentsTempState) {
    t8 = file_0 => {
      setAttachmentsTempState(getFilteredAttachmentsList(attachmentsTempState, file_0));
    };
    $[13] = attachmentsTempState;
    $[14] = setAttachmentsTempState;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== isPreFetching || $[17] !== t6 || $[18] !== t7 || $[19] !== t8) {
    t9 = <FileUploaderWithListedFiles source={FileSourceEnum.Email} files={t6} onSelect={t7} onDelete={t8} isPreFetching={isPreFetching} />;
    $[16] = isPreFetching;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== errors) {
    t10 = errors && <FieldErrorAndDescription error={errors} />;
    $[21] = errors;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t5 || $[25] !== t9) {
    t11 = <div className="flex flex-col gap-5">{t5}{t9}{t10}</div>;
    $[23] = t10;
    $[24] = t5;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t11 || $[28] !== t2 || $[29] !== t4) {
    t12 = <DisclosureBox defaultOpen={true} wrapperClassName={t2} title={t4}>{t11}</DisclosureBox>;
    $[27] = t11;
    $[28] = t2;
    $[29] = t4;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  return t12;
};
export default AttachmentsBlock;
function _temp(item) {
  return {
    ...item.file,
    ...("id" in item ? {
      id: item.id
    } : {})
  };
}